"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeTheme = exports.makeProxy = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var compose = function compose(themeType, theme) {
  var _themeType$split = themeType.split(/(?<!^)(?=[A-Z])/),
      _themeType$split2 = _toArray(_themeType$split),
      base = _themeType$split2[0],
      rest = _themeType$split2.slice(1);

  if (!theme.$compositions) return theme[base] || "";
  if (!theme.$compositions[base]) return theme[base] || "";
  return theme.$compositions[base].reduce(function (a, c) {
    var option = c.$default || "";

    var _iterator = _createForOfIteratorHelper(rest),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var opt = _step.value;

        if (opt in c) {
          option = c[opt];
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    a.push(option);
    return a;
  }, []).filter(Boolean).join(" ");
};

var composeDefaults = function composeDefaults(theme) {
  var composedTheme = JSON.parse(JSON.stringify(theme));

  var _loop = function _loop(key) {
    if (key === "$compositions") return "continue";
    var classNames = composedTheme[key].split(/\s+/),
        atRegex = /^[@](.+)$/;
    composedTheme[key] = classNames.map(function (c) {
      var match = atRegex.exec(c);

      if (match) {
        var _match2 = _slicedToArray(match, 2),
            _key2 = _match2[1];

        return composedTheme[_key2];
      }

      return c;
    }).join(" ");
  };

  for (var key in composedTheme) {
    var _ret = _loop(key);

    if (_ret === "continue") continue;
  }

  if (composedTheme.$compositions) {
    (function () {
      var _composedTheme$$compo = composedTheme.$compositions,
          _composedTheme$$compo2 = _composedTheme$$compo.$defaults,
          $defaults = _composedTheme$$compo2 === void 0 ? [] : _composedTheme$$compo2,
          rest = _objectWithoutProperties(_composedTheme$$compo, ["$defaults"]);

      for (var type in rest) {
        composedTheme.$compositions[type].forEach(function (options) {
          var _loop2 = function _loop2(option) {
            var atRegex = /^[@](.+)$/;
            options[option] = options[option].split(/\s+/).map(function (o) {
              var match = atRegex.exec(o);

              if (match) {
                var _match = _slicedToArray(match, 2),
                    _key = _match[1];

                return composedTheme[_key];
              }

              return o;
            }).join(" ");
            var $regex = /^\$(.+)$/,
                $match = $regex.exec(options[option]);

            if ($match) {
              var _$match = _slicedToArray($match, 2),
                  value = _$match[1];

              if (value in composedTheme) {
                options[option] = composedTheme[value];
                $defaults.push(value);
              }
            }
          };

          for (var option in options) {
            _loop2(option);
          }
        });
      }

      $defaults.forEach(function (themeType) {
        composedTheme[themeType] = compose(themeType, composedTheme);
      });
    })();
  }

  return composedTheme;
};

var handler = {
  get: function get(theme, definition, receiver) {
    if (!(definition in theme)) {
      theme[definition] = compose(definition, theme);
    }

    return theme[definition];
  }
};

var makeProxy = function makeProxy(theme) {
  return new Proxy(theme, handler);
};

exports.makeProxy = makeProxy;

var composeTheme = function composeTheme(theme) {
  return new Proxy(composeDefaults(theme), handler);
};

exports.composeTheme = composeTheme;